import { cssColor } from "shared/src/utils/cssUtils";
import { BackgroundFade } from "../components/BackgroundFade";
import { BackgroundPattern } from "../components/BackgroundPattern";
import { type CSSProperties } from "react";

const reflectionSize = { width: "50%", height: "100%" };
const secondaryReflectionSize = { width: 200, height: "100%" };

export const imagePresets = {
  reflection: `data:image/svg+xml,<svg width="auto" height="auto" viewBox="0 0 126 162" fill="none" xmlns="http://www.w3.org/2000/svg"><g style="mix-blend-mode:hard-light"><path d="M0.046875 2.27321L80.2414 2.35625L110.457 159.7L30.0317 159.768L0.046875 2.27321Z" fill="url(%23paint0_linear_11480_30231)"/><path d="M87.7354 2.30946L95.1822 2.34367L125.392 159.691L117.888 159.687L87.7354 2.30946Z" fill="url(%23paint1_linear_11480_30231)"/></g><defs><linearGradient id="paint0_linear_11480_30231" x1="97.6923" y1="3.75212" x2="97.6923" y2="155.918" gradientUnits="userSpaceOnUse"><stop stop-color="%238D8F8E"/><stop offset="1" stop-color="%238D8F8E" stop-opacity="0"/></linearGradient><linearGradient id="paint1_linear_11480_30231" x1="105.282" y1="1.84746" x2="122.68" y2="156.045" gradientUnits="userSpaceOnUse"><stop stop-color="%238D8F8E"/><stop offset="1" stop-color="%238D8F8E" stop-opacity="0"/></linearGradient></defs></svg>`,
};

const backgroundSettings = {
  backgroundRepeat: "no-repeat",
  backgroundSize: "70%"
};

export const patternPresets = {
  reflectionLeading: (pat, keyId) => {
    return (
      <BackgroundPattern
        alignment="left"
        {...pat}
        blendMode={pat?.blendMode ?? "color-dodge"}
        size={reflectionSize}
        key={keyId}
        className="cui-flex cui-justify-end"
      >
        <BackgroundPattern
          asBlock
          size={secondaryReflectionSize}
          backgroundSettings={backgroundSettings}
          image={imagePresets["reflection"]}
          className="cui-translate-x-2"
        />
      </BackgroundPattern>
    );
  },
  reflectionTrailing: (pat, keyId) => {
    return (
      <BackgroundPattern
        {...pat}
        blendMode={pat?.blendMode ?? "color-dodge"}
        size={reflectionSize}
        alignment="right"
        key={keyId}
        className="cui-justify-start cui-flex"
      >
        <BackgroundPattern
          flip
          asBlock
          size={secondaryReflectionSize}
          backgroundSettings={backgroundSettings}
          image={imagePresets["reflection"]}
          className="-cui-translate-x-2"
        />
      </BackgroundPattern>
    );
  },
};

export type FadePresetType = {
  width?: CSSProperties["width"];
  centerColor?: string;
  color?: string;
  opacity?: number;
};

export const fadePresets = {
  centerFade: (
    { width = 300, centerColor = "#1D1D1D", opacity = 1 }: FadePresetType,
    keyId
  ) => {
    return (
      <BackgroundFade
        alignment="center"
        size={{ width, height: "100%" }}
        gradientStops={[
          { color: "var(--neutrals-transparent)", location: 0 },
          { color: cssColor(centerColor), location: 0.5 },
          { color: "var(--neutrals-transparent)", location: 1 },
        ]}
        opacity={opacity}
        key={keyId}
      />
    );
  },
  topFade: ({ height = 50, color = "#1D1D1D", opacity = 1 }, keyId) => {
    return (
      <BackgroundFade
        alignment="top"
        size={{ width: "100%", height }}
        gradientStops={[
          { color: cssColor(color), location: 0 },
          { color: "var(--neutrals-transparent)", location: 1 },
        ]}
        opacity={opacity}
        key={keyId}
      />
    );
  },
  bottomFade: ({ height, color = "#1D1D1D", opacity = 1 }, keyId) => {
    return (
      <BackgroundFade
        alignment="bottom"
        size={{ width: "100%", height }}
        gradientStops={[
          { color: "var(--neutrals-transparent)", location: 0 },
          { color: cssColor(color), location: 1 },
        ]}
        opacity={opacity}
        key={keyId}
      />
    );
  },
};
